import { ReactNode } from 'react';
import { Box, ButtonProps, Tooltip } from '@mui/material';
import '@/styles/components/layout/BigIconButton.scss';
import BaseIconButton from '@/components/ui/BaseIconButton';

export interface BigIconButtonProps extends ButtonProps {
    tooltipTitle: string;
    children: ReactNode;
}

export default function BigIconButton({ tooltipTitle, children, ...props }: BigIconButtonProps) {
    return (
        <Tooltip title={tooltipTitle} placement="top" arrow>
            <Box>
                <BaseIconButton className="big-icon-button" {...props}>
                    {children}
                </BaseIconButton>
            </Box>
        </Tooltip>
    );
}
